import React, { Children } from 'react';
import { observer } from 'src/utils/mobx-react';
import { renderIcon } from 'src/ui/components/button/icon-only/button-utils';
import { ButtonIconBox } from 'src/ui/components/button/icon-only/ButtonIconOnly.style';
import { ButtonIconOnlyPropsType } from 'src/ui/components/button/icon-only/types';

export const ButtonIconOnly = observer(
    'ButtonIconOnly',
    ({
        appearance,
        children,
        className,
        dataTest,
        icon,
        isDisabled,
        isLoading = false,
        onClick,
        size,
        type = 'button',
    }: ButtonIconOnlyPropsType): JSX.Element => {
        const hasChildren = Children.count(children) > 0;

        return (
            <ButtonIconBox
                appearance={appearance}
                className={className}
                data-test={dataTest}
                disabled={isDisabled}
                isLoading={isLoading}
                onClick={onClick}
                size={size}
                type={type}
            >
                {renderIcon(isLoading, icon)}
                {hasChildren ? children : null}
            </ButtonIconBox>
        );
    }
);
